module.exports = __webpack_public_path__ + "static/meetup-c89d9a20de3d675c76a7d80b7f2748db.png";